import { useEffect, useState, useRef } from 'react';
import { getCurrentTokenWithoutRedirect } from '@adsk/acs-sc-web-platform-api';
import { useAlloyFeatureFlag } from '@adsk/alloy-provider';
export const INTERNAL_TIME_MS = 1000 * 60;
const useRefreshToken = () => {
  const refreshPromiseRef = useRef(null);
  const [disableInterval, setDisableInterval] = useState(false);
  const {
    value,
    loading
  } = useAlloyFeatureFlag('refresh-token-interval');
  useEffect(() => {
    let interval;
    if (!loading && value && interval === undefined && !disableInterval) {
      interval = setInterval(async () => {
        if (refreshPromiseRef.current) {
          return;
        }

        // This method checks if the token is about to expire or no token is present and tries refresh it
        try {
          refreshPromiseRef.current = getCurrentTokenWithoutRedirect();
          await refreshPromiseRef.current;
        } catch {
          // If the token is not refreshed, we disable the interval to avoid multiple calls
          setDisableInterval(true);
        } finally {
          refreshPromiseRef.current = null;
        }
      }, INTERNAL_TIME_MS);
    }
    return () => {
      clearInterval(interval);
      refreshPromiseRef.current = null;
    };
  }, [loading, value, disableInterval]);
};
export const RefreshTokenSetter = () => {
  useRefreshToken();
  return null;
};
//# sourceMappingURL=RefreshTokenSetter.js.map